import React, { useMemo, useState, useEffect } from 'react';
import Loadable from 'react-loadable';
import { connect } from 'react-redux';
import cruiseData from './Data/cruise.json';
import CruiseDataCard from './CruiseDataCard';
import OmnitureUtils from '../common/utils/Omniture/OmnitureUtils';
import { getMMT_HLD_OBJ } from '../common/utils/appUtils';
import './cruise.scss';

const QueryFormCruise = Loadable({
  loader: () => import(/* webpackChunkName: 'QueryFormCruise' */ '../sendQuery/src/QueryPage'),
  loading: () => <div />,
});

const generateCruiseData = (typeDestination, cruiseJSON) => {
  const temp = {};
  const destinationsCategories = cruiseJSON.cruiseTypes[typeDestination]?.categories;
  destinationsCategories?.forEach(element => {
    temp[element.categoryName] = element.cruiseOptions;
  });
  return temp;
};

const CruiseComponent = ({ typeDestination, seoMetaData, cruiseBranch }) => {
  useEffect(() => {
    const MMT_HLD = getMMT_HLD_OBJ();
    MMT_HLD.branch = cruiseBranch;
  }, []);

  const { categoriesObject, categoryNames } = useMemo(() => {
    const categoriesObject = generateCruiseData(typeDestination, cruiseData);
    const categoryNames = Object.keys(categoriesObject);
    return { categoriesObject, categoryNames };
  }, [typeDestination]);

  const [activeTab, setActiveTab] = useState(categoryNames?.[0] || '');
  const [showContactManagement, setShowContactManagement] = useState(false);
  const onSelectTab = (name, tabIndex) => {
    setActiveTab(name);
    OmnitureUtils.trackClickEvent({ prop54: 'Tabswitch', prop1: `${name} | ${tabIndex + 1}` }); // added + 1 for index as discussed with product
  };

  const handleBookNowClick = () => {
    setShowContactManagement(!showContactManagement);
    OmnitureUtils.trackClickEvent({ prop54: 'Book_now' });
  };
  return (
    <>
      {categoriesObject && (
        <div className={`cruiseListing ${seoMetaData ? '' : 'margin-top'}`}>
          {categoryNames && (
            <>
              {!categoriesObject.Default && (
                <div className="tabs">
                  {categoryNames.map((category, index) => (
                    <p
                      key={index}
                      className={`categoryTabs ${category === activeTab ? 'activeTab' : ''} `}
                      onClick={() => onSelectTab(category, index)}
                    >
                      {category}
                    </p>
                  ))}
                </div>
              )}
              {categoriesObject[activeTab] && (
                <CruiseDataCard
                  cruiseCardData={categoriesObject[activeTab]}
                  onBookNowClick={handleBookNowClick}
                />
              )}
            </>
          )}
        </div>
      )}
      {showContactManagement && <QueryFormCruise onClose={handleBookNowClick} />}
    </>
  );
};

const mapStateToProps = ({ seo }) => ({
  seoMetaData: seo.metaData,
  cruiseBranch: seo.cruiseBranch,
});

export default connect(mapStateToProps, null)(CruiseComponent);
